import { render } from "./CodeCopy.vue?vue&type=template&id=705abd2b&scoped=true"
import script from "./CodeCopy.vue?vue&type=script&lang=js"
export * from "./CodeCopy.vue?vue&type=script&lang=js"

import "./CodeCopy.vue?vue&type=style&index=0&id=705abd2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705abd2b"]])

export default __exports__